import React from "react";
import { IoFastFood } from "react-icons/io5";

import { Header } from "../../../common";
import { CardView } from "../../../controls";

const HomeView = ({}) => {
  return (
    <div className="home-container">
      <h1>Home Screen</h1>
    </div>
  );
};

export default HomeView;
